import type { CSSProperties, PropsWithChildren } from 'react';
import React from 'react';

interface LinkProps {
  href: string;
  alt: string;

  style?: CSSProperties | undefined;
  classNames?: string[];
  target?: '_blank';
  rel?: 'noreferrer nofollow';
}

export const Link: React.FC<PropsWithChildren<LinkProps>> = (
  props: PropsWithChildren<LinkProps>,
) => {
  const classNames = [];

  if (props.classNames !== undefined) {
    classNames.push(...props.classNames);
  }

  return (
    <a
      href={props.href}
      style={props.style}
      className={classNames.join(' ')}
      title={props.alt}
      aria-label={props.alt}
      target={props.target}
      rel={props.rel}
    >
      {props.children}
    </a>
  );
};

// Gatsby version
// export const Link = (props: LinkProps): ReactElement => {
//   return (
//     <GatsbyLink
//       to={props.href}
//       style={props.style}
//       className={props.className}
//     >{props.children}
//     </GatsbyLink>
//   )
// }
